import { FaEdit } from "react-icons/fa";
import { FiCheck, FiTrash2 } from "react-icons/fi";
import styled from "styled-components";

import FlexBox from "../../common/FlexBox";
import { Body2, H4 } from "../../common/Headings";
import {
  DAVYS_GREY_700,
  DAVYS_GREY_800,
  ERROR_RED,
  MOSS_GREEN_800,
  SUCCESS_GREEN,
  SUCCESS_GREEN_800,
} from "../../common/colors";

const ActiveCustomizationHeader = styled(FlexBox)`
  justify-content: space-between;
  align-items: center;
`;

const IconTextButton = styled.button`
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 0.375rem;
  cursor: pointer;
  padding: 0;
  font-size: 0.875rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: ${props => (props.danger ? ERROR_RED[800] : DAVYS_GREY_800)};
  text-decoration: underline;
`;

const SuccessBanner = styled(FlexBox)`
  flex-direction: column;
  background: ${SUCCESS_GREEN[100]};
  border: 1px solid ${SUCCESS_GREEN[500]};
  border-radius: 0.5rem;
  padding: 1rem;
  gap: 0.5rem;
`;

const SuccessTitle = styled(FlexBox)`
  align-items: center;
  gap: 0.5rem;
  color: ${MOSS_GREEN_800};
`;

const BannerTitleText = styled(Body2)`
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 700;
`;

const SavedCustomizationPanel = ({
  additionalPrompt,
  handleEdit,
  setShowRemoveConfirm,
}) => (
  <>
    <ActiveCustomizationHeader>
      <H4 bold>Active customization</H4>
      <FlexBox columnGap="1rem">
        <IconTextButton type="button" onClick={handleEdit}>
          <FaEdit size={20} />
          Edit
        </IconTextButton>
        <IconTextButton
          type="button"
          danger
          onClick={() => setShowRemoveConfirm(true)}
        >
          <FiTrash2 size={20} />
          Remove
        </IconTextButton>
      </FlexBox>
    </ActiveCustomizationHeader>

    <SuccessBanner>
      <SuccessTitle>
        <FiCheck size={16} color={SUCCESS_GREEN_800} />
        <BannerTitleText bold color={MOSS_GREEN_800}>
          Saved Customization
        </BannerTitleText>
      </SuccessTitle>
      <Body2>{additionalPrompt}</Body2>
    </SuccessBanner>

    <Body2 color={DAVYS_GREY_700}>
      This customisation will be appended to the base prompt for every new
      session note you generate.
    </Body2>
  </>
);

export default SavedCustomizationPanel;
